import { FormStore, GlobalStore, UserStore } from '@roc/feature-app-core';
import { DateFormat, formatDate, parseDate } from '@roc/feature-utils';
import { action, makeObservable } from 'mobx';

const finalDetailsForm = {
  fields: {
    preferredClosingAttorney: {
      value: '',
      error: null,
      rule: '',
    },
    preferredTitle: {
      value: '',
      error: null,
      rule: '',
    },
    requestedClosingDate: {
      value: null,
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class FinalDetailsStore {
  protected globalStore: GlobalStore;
  private userStore: UserStore;

  public finalDetailsFormStore: FormStore;

  constructor(globalStore, userStore) {
    this.globalStore = globalStore;
    this.userStore = userStore;
    this.finalDetailsFormStore = new FormStore(finalDetailsForm, globalStore);
    makeObservable(this, {
      reset: action,
    });
  }

  reset() {
    this.finalDetailsFormStore.reset();
  }

  loadClosingData(quote) {
    this.finalDetailsFormStore.loadForm({
      preferredClosingAttorney: quote.closingData?.preferredClosingAttorney,
      preferredTitle: quote.closingData?.preferredTitle,
      requestedClosingDate: parseDate(quote.closingData?.requestedClosingDate),
    });
  }

  getClosingData() {
    const values = this.finalDetailsFormStore.getFormValues();
    return {
      preferredClosingAttorney: values.preferredClosingAttorney ?? null,
      preferredTitle: values.preferredTitle ?? null,
      requestedClosingDate: values.requestedClosingDate
        ? formatDate(values.requestedClosingDate, DateFormat.MMDDYYYY)
        : null,
    };
  }

  getAssignment(savedQuote: any) {
    const isEditingLoan = !!savedQuote?.loanNumber;
    if (isEditingLoan || savedQuote?.assignment) {
      return savedQuote.assignment;
    }
    if (this.userStore.isSeniorOriginator || this.userStore.isJrOriginator) {
      const originatorId = this.userStore.userInformation?.userId;
      const originatorName = this.userStore.userInformation?.fullName;
      return { originatorId, originatorName };
    } else {
      return null;
    }
  }
}
